
<b-container style="margin-top: 70px">
  <b-row>
    <b-col sm="12" md="12" lg="8" xl="8">
      <configuration-dialog :template-version="template_version"
                            :quote-product="quote_product"
                            :is-public="isPublic"></configuration-dialog>
    </b-col>
    <b-col sm="12" md="12" lg="4" xl="4">
      <div class="position-sticky" style="top:70px">
        <configuration-summary :template-version="template_version"
                               :quote-product="quote_product"
                               :price-name="summaryPriceName"
                               :debug-enabled="debugEnabled"></configuration-summary>
        <configuration-dialog-buttons :quote-product="quote_product" :is-public="isPublic" :is-bto="true"></configuration-dialog-buttons>
      </div>
    </b-col>
  </b-row>
</b-container>
